module.exports = __webpack_public_path__ + "static/media/Lato-Black.9ab28490.woff2";